export default [
	{
		path: "council-period",
		meta: {
      helpTag: "council:council-period",
    },
		component: () =>
			import(
				"../../views/council-public/councilperiod"
			),
		children: [
			{
				path: "",
				name: "Council.CouncilPeriod",
				component: () =>
					import(
						"../../views/council-public/councilperiod/list"
					),
			},
			{
				path: "member/:cp_hexkey/:cpm_hexkey/:tab?/:cpp_hexkey?",
				name: "Council.CouncilPeriod.Member",
				component: () =>
					import(
						"../../views/council-public/councilperiod/detail"
					),
			},
		],
	},
	{
		path: "council-period/party",
		meta: {
      helpTag: "council:council-period-party",
    },
		component: () =>
			import(
				"../../views/council-public/councilperiod/party"
			),
		children: [
			{
				path: ":cp_hexkey/:pa_hexkey/:cpp_hexkey?",
				name: "Council.CouncilPeriodParty",
				component: () =>
					import(
						"../../views/council-public/councilperiod/party/list"
					),
			},
			{
				path: "details/:cp_hexkey/:pa_hexkey",
				name: "Council.CouncilPeriodParty.DetailDialog",
				component: () =>
					import(
						"../../components/council-public/councilperiod/party/detailDialog"
					),
			},
		],
	},
	{
		path: "council-period/votes/:cp_hexkey/:cpm_hexkey/:cpp_hexkey?",
		redirect: (to) => {
			return {
				name: "Council.CouncilPeriod.Member",
				params: {
					cp_hexkey: to.params.cp_hexkey,
					cpm_hexkey: to.params.cpm_hexkey,
					cpp_hexkey: to.params.cpp_hexkey,
					tab: 'votes',
				},
			};
		},
	},
	{
		path: "council-period/documents/:cp_hexkey/:cpm_hexkey",
		redirect: (to) => {
			return {
				name: "Council.CouncilPeriod.Member",
				params: {
					cp_hexkey: to.params.cp_hexkey,
					cpm_hexkey: to.params.cpm_hexkey,
					cpp_hexkey: to.params.cpp_hexkey,
					tab: 'documents',
				},
			};
		},
	},
	{
		path: "council-period/videos/:cp_hexkey/:cpm_hexkey",
		redirect: (to) => {
			return {
				name: "Council.CouncilPeriod.Member",
				params: {
					cp_hexkey: to.params.cp_hexkey,
					cpm_hexkey: to.params.cpm_hexkey,
					tab: 'videos',
				},
			};
		},
	},
];
